import { globals } from '@/src/globals'

declare const Masonry

export const masonryElectroReferences = (): void => {
  const allElectroReferenceLists = document.querySelectorAll('.js-electroReferencesList') as unknown as HTMLElement[]

  if (allElectroReferenceLists.length > 0) {
    allElectroReferenceLists.forEach((electroReferenceList: HTMLElement) => {
      const electroReferenceWrapper = electroReferenceList.querySelector('.js-electroReferencesList-wrapper') as unknown as HTMLElement

      const masonry = new Masonry(electroReferenceWrapper, {
        itemSelector: '.js-electroReferencesList-single',
        horizontalOrder: true,
        transitionDuration: 0
      })
      globals.masonryList.push(masonry)
    })
  }
}
